import videojs from 'video.js';

// Плагин перезагружает плеер при смене базового урла (канала в вебкастере) hls фрагментов.
class HlsFragBaseMonitoring extends videojs.getPlugin("plugin") {
  constructor(player, options) {
    super(player, options);

    this.savedFragmentBasePath = '';
    // при рестарте неизвестно в каком состоянии плеер, поэтому отслеживается играет ли он
    this.isPlay = !player.paused();
    this.player.on('Html5HlsJS/ready', () => {
      this.setHlsListeners();
    });

    this.player.on('play', () => {
      this.isPlay = true;
    });

    this.player.on('pause', () => {
      this.isPlay = false;
    });
  }

  setHlsListeners() {
    const hls = this.player.hls_;
    if (!hls) return;

    hls.on('hlsLevelUpdated', () => {
      handleUpdateFragBasePath();
    });

    const handleUpdateFragBasePath = () => {
      const hlsLevel = this.getHlsLevel();
      if (!hlsLevel) return;

      // Целевой url имеет вид /client/channel/quality/1724/27/10/1724271027988.ts
      const firstFragmentRelUrl = hlsLevel.details.fragments[0].relurl;
      if (!firstFragmentRelUrl) return;

      const firstFragmentBasePath = this.extractBasePath(firstFragmentRelUrl);
      if (!firstFragmentBasePath) return;

      if (!this.savedFragmentBasePath) {
        this.savedFragmentBasePath = firstFragmentBasePath;
        return;
      }
      if (this.savedFragmentBasePath !== firstFragmentBasePath) {
        this.savedFragmentBasePath = firstFragmentBasePath;
        this.reloadPlayer();
      }
    }
  }

  getHlsLevel() {
    const hls = this.player.hls_;
    if (!hls || !hls.levels) return;

    const hlsCurrentLevel = hls.currentLevel === -1 ? 0 : hls.currentLevel;
    const hlsLevel = hls.levels[hlsCurrentLevel];
    return hlsLevel;
  }

  reloadPlayer() {
    this.player.src(this.player.currentSrc());
    this.player.load();
    if (this.isPlay) {
      this.player.play();
    } else {
      this.player.pause();
    }
  }

  extractBasePath(url) {
    // Достает часть https://cdnbl.video2.matchtv.zxz.su/matchtv/matchtv-test если есть часть /360/1731/35/87/1731358799927
    const match = url.match(/^.*?(?=\/[^/]+\/\d{4}\/\d{2}\/\d{2}\/\d{13})/);
    if (!match) return;
    return match[0];
  }
}

videojs.registerPlugin('hlsFragBaseMonitoring', HlsFragBaseMonitoring);